import { createFileRoute } from '@tanstack/react-router';
import { AdminCreateSheet } from '@/pages/admins/create-sheet';

export const Route = createFileRoute('/admin/_layout/admins/_layout/new')({
  component: () => <AdminCreateSheet />,
});
